import React from "react";
import styled from "styled-components";
import { Text4, Text5 } from "./styles";

const Wraper = styled.div`
  width: 180px;
  height: 160px;
  border-radius: 13px;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 39.91735px 0px rgba(0, 0, 0, 0.15);
  @media screen and (min-width: 1301px) and (max-width: 1366px) {
    width: 142px;
    height: 142px;
  } 
  @media screen and (min-width: 1024px) and (max-width: 1300px) {
    width: 134px;
    height: 134px;
  } 
  @media screen and (max-width: 1024px) {
    width: calc((100% - 30px) / 3);
    height: 140px;
  }
  @media screen and (max-width: 500px) {
    height: 120px;
  }
  @media screen and (max-width: 390px) {
    height: 100px;
  }
  @media screen and (max-width: 360px) {
    height: 90px;
  }
`;

export const CardOption = ({ value, title }) => {
  return (
    <Wraper>
      <div className="max-w-full px-3">
        <Text4>{value ?? 0}</Text4>
      </div>
      <div className="mt-2">
        <Text5>{title}</Text5>
      </div>
    </Wraper>
  );
};
